import React from 'react';
import { HStack, VStack, Text, Box } from '@chakra-ui/react';
import { i18n } from '@investigator/shared/localization';
import { useEntitiesContext } from '../../../context';
import { ModalView } from '@investigator/features/entities/types';
import ArrowRightAltSharpIcon from '@gamma/ui/icons/ArrowRightAltSharpIcon';
import type { KeyFinding } from '@investigator/shared/generated/graphql';

const modalCopy = i18n.pages.entities.entityAnalysisModal.keyFindings;

export interface KeyFindingsRowProps extends KeyFinding {
  index: number;
  descriptionTag: React.ReactNode;
}

export const KeyFindingsRow: React.FC<KeyFindingsRowProps> = ({
  title,
  descriptionTag,
  index,
}) => {
  const {
    analysisModal: {
      modalNavigation: { navigateTo },
    },
  } = useEntitiesContext();

  return (
    <Box
      width="100%"
      bgColor="layer.2"
      p={4}
      borderRadius="md"
      cursor="pointer"
      onClick={() => navigateTo(ModalView.KeyFindingsDetail, index)}
      _hover={{
        bg: 'layer.2.active',
      }}
      transition="background 0.2s"
    >
      <HStack width="100%" spacing={4} align="start">
        <VStack width="100%" align="start" spacing={2} flex={1}>
          <Text fontWeight="bold">{title}</Text>
          <Text color="text.secondary">{descriptionTag}</Text>
        </VStack>
        <HStack spacing={1} color="text.link" flexShrink={0}>
          <Text fontSize="sm" whiteSpace="nowrap">
            {modalCopy.viewDetails}
          </Text>
          <ArrowRightAltSharpIcon size="sm" />
        </HStack>
      </HStack>
    </Box>
  );
};
